/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeoPosition } from './GeoPosition';
export type WorkPackage = {
    readonly id: string;
    tenant_id: string;
    construction_site_id: string;
    name: string;
    display_name: string;
    construction_site_manager_id: string;
    construction_site_manager_name?: string | null;
    service_category_id: string;
    location: string | null;
    location_geo_position?: GeoPosition | null;
    note?: string | null;
    planned_minutes: number | null;
    calculated_minutes: number | null;
    effective_calculated_minutes: number | null;
    actual_minutes: number;
    wage_type: WorkPackage.wage_type;
    commute_expenses_enabled: boolean;
    can_modify_accounting_fields: boolean;
    active: boolean;
};
export namespace WorkPackage {
    export enum wage_type {
        CHARGEABLE_HOURS = 'chargeable_hours',
        PREPARATION = 'preparation',
    }
}

